import * as React from 'react';

export const Details: React.VoidFunctionComponent<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" strokeWidth="2" {...props}>
			<path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor"></path>
		</svg>
	);
};
